import React from 'react';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import classNames from 'classnames'
import { images } from '../../../../assets/image';
import { Button } from '@material-ui/core';
import { ColorPalette } from 'screens/addEditCustomScreen/widgetsCardData/horizontalWidgetCard/types';

const ClubOccupancyWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const {
    widgetParams,
    defaultPaddings,
  } = props;

  return (
    <div
      className={classNames([styles.widgetContainer])}
      style={defaultPaddings}
    >
      <img
        src={images.clubOccupancyPlaceholder}
        className={classNames([styles.widgetImage])}
      />
      <div
        className={classNames([styles.widgetData])}
        style={defaultPaddings}
      >
        <div className={classNames([styles.titleContainer])} >
          <img
            src={images.star}
            className={classNames([styles.starIcon])}
          />
          <p
            className={classNames([styles.widgetTitle])}
          >
            {'Maadi Club'}
          </p>
        </div>

        <p
          className={classNames([styles.widgetDescription])}
        >
          {widgetParams.description}
        </p>
      </div>
    </div>
  );
};

export default ClubOccupancyWidget;
